import { ID } from '../../utils/codecUtils';
import { Organization } from '../models/organization';
import { organizationSchema } from '../models/organization.schema';

export type PatchOrganizationPayolad = Partial<Organization>;

export const patch = (
  organizationId: ID,
  payload: PatchOrganizationPayolad
) => {
  return {
    endpoint: `/organizations/${organizationId}`,
    method: 'PATCH',
    responseSchema: organizationSchema,
    payloadSchema: organizationSchema.partial(),
    payload,
  } as const;
};
